import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import { modalFooterCss } from "./ExportablesModalFooter.styles";
import MobileActions from "./MobileActions";
import StudentActions from "./StudentActions";
import TeacherActions from "./TeacherActions";

interface ExportablesModalFooterProps {
  isStudent?: boolean;
}

const ExportablesModalFooter = ({
  isStudent = false,
}: ExportablesModalFooterProps) => {
  const { renderOnMobile } = useExportablesContext();
  return (
    <div css={modalFooterCss}>
      {!renderOnMobile && <MobileActions />}
      {isStudent ? <StudentActions /> : <TeacherActions />}
    </div>
  );
};

export default ExportablesModalFooter;
